import { motion } from 'motion/react';
import React from 'react';

interface WaveTextProps {
	text: string;
}

export const WaveText: React.FC<WaveTextProps> = ({ text }) => {
	return (
		<div className='flex mx-0.5' aria-label={text} tabIndex={0} role='text'>
			{text.split('').map((char, index) => (
				<motion.span
					key={index}
					className='font-semibold'
					initial={{ y: 0 }}
					animate={{ y: [0, -8, 0] }}
					transition={{
						duration: 1.2,
						repeat: Infinity,
						delay: index * 0.08,
						ease: 'easeInOut',
					}}
					style={{ willChange: 'transform' }}>
					{char}
				</motion.span>
			))}
		</div>
	);
};
